
  export default {
    mounted() {
      const chartData = JSON.parse(this.el.dataset.chartData || "[]")
      const i18n = JSON.parse(this.el.dataset.i18n || "null") || window.I18n || {}
      this.renderChart(chartData, i18n)
    },
    renderChart(chartData, i18n) {
      const t = (key) => i18n[key]
      if (chartData.length === 0) {
        this.el.innerHTML = `<div class="flex items-center justify-center h-full text-text-muted">${t("No throughput data available")}</div>`
        return
      }

      import("highcharts").then((Highcharts) => {
        const categories = chartData.map(d => d.name)
        const receivedData = chartData.map(d => d.total_received)
        const shippedData = chartData.map(d => d.total_shipped)

        window.Enaia.applyHighchartsTheme(Highcharts.default)
        Highcharts.default.chart(this.el.id, {
          chart: {
            type: 'bar',
            backgroundColor: 'transparent'
          },
          title: { text: null },
          xAxis: {
            categories: categories,
            labels: {
              style: {
                fontSize: '12px',
                color: '#374151'
              }
            }
          },
          yAxis: {
            min: 0,
            title: {
              text: t("Units"),
              style: { fontSize: '12px' }
            }
          },
          legend: {
            enabled: true,
            align: 'center',
            verticalAlign: 'bottom'
          },
          tooltip: {
            shared: true,
            useHTML: true,
            formatter: function() {
              const location = this.x
              const received = this.points[0]?.y || 0
              const shipped = this.points[1]?.y || 0
              const total = received + shipped
              return `<div style="padding: 8px;">
                <strong>${location}</strong><br/>
                ${t("Received")}: ${received.toLocaleString()}<br/>
                ${t("Shipped")}: ${shipped.toLocaleString()}<br/>
                ${t("Total")}: ${total.toLocaleString()}
              </div>`
            }
          },
          plotOptions: {
            bar: {
              stacking: 'normal',
              borderRadius: 4
            }
          },
          series: [{
            name: t("Received"),
            data: receivedData,
            color: '#0086e6'
          }, {
            name: t("Shipped"),
            data: shippedData,
            color: '#F97316'
          }],
          credits: { enabled: false }
        })
      })
    }
  }
